import {
  PatientSync,
  SyncServiceType,
  SyncState,
} from "model/patient-sync.model";

/** ---- Dispatch Types ---- */
export const LOAD_PATIENTSYNC_START = "LOAD_PATIENTSYNC_START";
export const LOAD_PATIENTSYNC_SUCCESS = "LOAD_PATIENTSYNC_SUCCESS";
export const LOAD_PATIENTSYNC_ERROR = "LOAD_PATIENTSYNC_ERROR";
export const SET_PATIENTSYNC = "SET_PATIENTSYNC";
export const SET_PATIENTSYNC_SUCCESS = "SET_PATIENTSYNC_SUCCESS";
export const SET_PATIENTSYNC_ERROR = "SET_PATIENTSYNC_ERROR";

/** ---- Dispatch Interfaces ---- */
interface CreatePatientSync {
  type: typeof SET_PATIENTSYNC;
  payload: {
    serviceType: SyncServiceType;
    syncState: SyncState;
  };
}

interface CreatePatientSyncSuccess {
  type: typeof SET_PATIENTSYNC_SUCCESS;
  payload: PatientSync;
}

interface CreatePatientSyncError {
  type: typeof SET_PATIENTSYNC_ERROR;
}

interface LoadPatientSyncStartAction {
  type: typeof LOAD_PATIENTSYNC_START;
}

interface LoadPatientSyncSuccessAction {
  type: typeof LOAD_PATIENTSYNC_SUCCESS;
  payload: PatientSync[];
}

interface LoadPatientSyncErrorAction {
  type: typeof LOAD_PATIENTSYNC_ERROR;
}

export type PatientSyncAction =
  | LoadPatientSyncStartAction
  | LoadPatientSyncSuccessAction
  | LoadPatientSyncErrorAction
  | CreatePatientSync
  | CreatePatientSyncSuccess
  | CreatePatientSyncError;
